import React from 'react';
import Menu from './Menu';
import { MenuItem } from './MenuItem';

interface ViewMenuProps {
  items: MenuItem[];
}

const ViewMenu: React.FC<ViewMenuProps> = ({ items }) => {
  return <Menu items={items} />;
};

export default ViewMenu; 